"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "font-bold text-red text-[24px] mt-4 uppercase" };
const _hoisted_3 = {
    key: 0,
    class: "font-bold mt-4"
};
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "font-bold text-red text-[24px] mt-4 uppercase" };
const _hoisted_6 = {
    key: 0,
    class: "font-bold mt-4"
};
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const couponStore_1 = require("../../stores/coupon/couponStore");
const vue_router_1 = require("vue-router");
const toastStore_1 = require("../../stores/toast/toastStore");
const i18n_1 = require("../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Coupons',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f;
        const couponStore = (0, couponStore_1.useCouponStore)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const isDisplayArchivedCoupons = (0, vue_3.ref)(false);
        const listFields = (0, vue_3.ref)([
            {
                key: "name",
                label: (_a = (0, i18n_1.trans)("name", "Name", "coupons")) !== null && _a !== void 0 ? _a : "Name",
                value: "name",
            },
            {
                key: "description",
                label: (_b = (0, i18n_1.trans)("description", "Description", "coupons")) !== null && _b !== void 0 ? _b : "Description",
                value: "description",
            },
            {
                key: "originalValue",
                label: (_c = (0, i18n_1.trans)("original_value", "Original Value", "coupons")) !== null && _c !== void 0 ? _c : "Original Value",
                value: "originalValue",
            },
            {
                key: "remainValue",
                label: (_d = (0, i18n_1.trans)("remain_value", "Remain Value", "coupons")) !== null && _d !== void 0 ? _d : "Remain Value",
                value: "remainValue",
            },
            {
                key: "beginDate",
                label: (_e = (0, i18n_1.trans)("begin_date", "Begin Date", "coupons")) !== null && _e !== void 0 ? _e : "Begin Date",
                value: "beginDate",
            },
            {
                key: "endDate",
                label: (_f = (0, i18n_1.trans)("end_date", "End Date", "coupons")) !== null && _f !== void 0 ? _f : "End Date",
                value: "endDate",
            },
        ]);
        const displayArchivedCoupons = () => {
            isDisplayArchivedCoupons.value = !isDisplayArchivedCoupons.value;
            return isDisplayArchivedCoupons.value;
        };
        (0, vue_3.watchEffect)(() => {
            couponStore.getCustomerCoupons(router).catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("active_coupons", "Active Coupons", "coupons")), 1),
                ((0, vue_2.unref)(couponStore).activeCustomerCoupons.length === 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("have_no_active_coupons", "You have no active coupons", "coupons")), 1))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(couponStore).activeCustomerCoupons.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                        key: 1,
                        fields: listFields.value,
                        "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((listFields).value = $event)),
                        items: (0, vue_2.unref)(couponStore).activeCustomerCoupons,
                        striped: "",
                        condensed: "",
                        panel: "",
                        class: "my-4",
                        isBusy: (0, vue_2.unref)(couponStore).loading
                    }, {
                        "cell-originalValue": (0, vue_2.withCtx)(({ item: coupon }) => [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.n)(coupon.originalValue, "currency", "hu-HU")), 1)
                        ]),
                        "cell-remainValue": (0, vue_2.withCtx)(({ item: coupon }) => [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.n)(coupon.remainValue, "currency", "hu-HU")), 1)
                        ]),
                        _: 1
                    }, 8, ["fields", "items", "isBusy"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("button", {
                    class: "btn btn-rounded btn-primary max-w-max",
                    onClick: displayArchivedCoupons
                }, (0, vue_2.toDisplayString)(isDisplayArchivedCoupons.value
                    ? (0, vue_2.unref)(i18n_1.trans)("hide_archived_coupons", "Hide archived coupons", "coupons")
                    : (0, vue_2.unref)(i18n_1.trans)("display_archived_coupons", "Display archived coupons", "coupons")), 1),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "fade" }, {
                    default: (0, vue_2.withCtx)(() => [
                        (isDisplayArchivedCoupons.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("archived_coupons", "Archived Coupons", "coupons")), 1),
                                ((0, vue_2.unref)(couponStore).archivedCustomerCoupons.length === 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("have_no_archived_coupons", "You have no archived coupons", "coupons")), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.unref)(couponStore).archivedCustomerCoupons.length > 0 &&
                                    isDisplayArchivedCoupons.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                                        key: 1,
                                        fields: listFields.value,
                                        "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((listFields).value = $event)),
                                        items: (0, vue_2.unref)(couponStore).archivedCustomerCoupons,
                                        striped: "",
                                        condensed: "",
                                        panel: "",
                                        class: "mt-4",
                                        isBusy: (0, vue_2.unref)(couponStore).loading
                                    }, {
                                        "cell-originalValue": (0, vue_2.withCtx)(({ item: coupon }) => [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.n)(coupon.originalValue, "currency", "hu-HU")), 1)
                                        ]),
                                        "cell-remainValue": (0, vue_2.withCtx)(({ item: coupon }) => [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.n)(coupon.remainValue, "currency", "hu-HU")), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["fields", "items", "isBusy"]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
